import { Link } from 'react-router-dom';

const activitiesData = [
  {
    title: 'Youth Digital Bootcamp 2026',
    date: '15 July 2026',
    location: 'Butterworth Community Hall',
    category: 'Workshop',
    description: 'A 3-day intensive bootcamp covering web development, digital marketing, and basic cybersecurity for youth aged 16-25.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Youth%20digital%20bootcamp%20workshop%20in%20community%20hall%2C%20students%20working%20on%20laptops%2C%20energetic%20learning%20environment%2C%20modern%20classroom%20setup%2C%20Malaysian%20youth%2C%20bright%20natural%20lighting&width=700&height=500&seq=activity-card-1-2026&orientation=landscape',
  },
  {
    title: 'Community Clean-Up & Tech Day',
    date: '2 August 2026',
    location: 'Kampung Gajah Area',
    category: 'Community',
    description: 'Combined environmental clean-up with free tech consultation booths for local residents. Volunteers needed!',
    imageUrl: 'https://readdy.ai/api/search-image?query=Community%20cleanup%20event%20in%20Malaysian%20village%2C%20volunteers%20picking%20up%20litter%2C%20tech%20booth%20set%20up%20nearby%2C%20sunny%20day%2C%20community%20spirit%2C%20green%20surroundings&width=700&height=500&seq=activity-card-2-2026&orientation=landscape',
  },
  {
    title: 'Mentorship Open Day',
    date: '20 September 2026',
    location: 'INSAN PERWIRA Center',
    category: 'Networking',
    description: 'Meet our mentors, learn about the program, and sign up for the next mentorship cycle. Open to all youth in Pulau Pinang.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20day%20networking%20event%20with%20mentors%20and%20youth%20in%20modern%20center%2C%20name%20tags%2C%20coffee%20and%20snacks%2C%20friendly%20conversations%2C%20warm%20indoor%20lighting%2C%20professional%20yet%20casual&width=700&height=500&seq=activity-card-3-2026&orientation=landscape',
  },
];

export default function ActivitiesGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold tracking-wider uppercase text-primary-600 mb-3">
            Upcoming Events
          </span>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 leading-tight">
                Activities &amp; Events
              </h2>
              <p className="text-foreground-600 text-sm md:text-base mt-2">
                Join us in making a difference — upcoming programs and community gatherings
              </p>
            </div>
            <Link
              to="/activities"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              View All Activities
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
          {activitiesData.map((activity, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 group cursor-pointer hover:border-background-300/80 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={activity.imageUrl}
                  alt={activity.title}
                  title={`${activity.title} - INSAN PERWIRA`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800">
                  {activity.category}
                </span>
              </div>

              {/* Content */}
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line text-sm"></i>
                    {activity.date}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-map-pin-line text-sm"></i>
                    {activity.location}
                  </span>
                </div>
                <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">
                  {activity.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                  {activity.description}
                </p>
                <Link
                  to="/activities"
                  className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
                >
                  Learn More
                  <i className="ri-arrow-right-line text-sm"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}